// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3G73i","title":"ClientInsurance_title__2coHI","itemText":"ClientInsurance_itemText__179Js"};